import * as React from 'react';
import type { MenuItem } from '@/types';

import {
  AndroidIcon,
  AppleIcon,
  WebIcon,
  RestIcon,
  UnityIcon,
  EdgeauthIcon,
  ReactIcon,
  PageIcon,
} from '../components/Icons';
export { gettingStartedMenu } from './getting-started';
export { restDocs } from './rest-api';
export { androidDocs } from './android';
export { edgeauthDocs } from './edge-auth';
export { webDocs } from './web-sdk';
export { unityDocs } from './unity';
export { iosDocs } from './ios';
export { reactNativeDocs } from './react-native';
export * from './knowledge-base';
export * from './home';
export { rootSideMenu } from './side-menu';

/**
 * A general menu for the site's main documentation sections
 */
export const docTiles: MenuItem[] = [
  {
    label: 'REST API',
    icon: <RestIcon />,
    path: '/sdk_ref/rest-api/overview',
  },
  { label: 'Web SDK', icon: <WebIcon />, path: '/sdk_ref/web' },
  {
    label: 'Android SDK',
    icon: <AndroidIcon />,
    path: '/sdk_ref/android/overview',
  },
  { label: 'iOS SDK', icon: <AppleIcon />, path: '/sdk_ref/ios/overview' },
  { label: 'Unity SDK', icon: <UnityIcon />, path: '/sdk_ref/unity/overview' },
  {
    label: 'React Native SDK',
    icon: <ReactIcon />,
    path: '/sdk_ref/react-native/overview',
  },
  {
    label: 'EdgeAuth SDK',
    icon: <EdgeauthIcon />,
    path: '/sdk_ref/edgeauth/overview',
  },
];

/**
 * Returns a custom icon for each type of search result
 */
export function getIcon(path: string) {
  const icon = path.includes('/web/') ? (
    <WebIcon />
  ) : path.includes('/rest-api/') ? (
    <RestIcon />
  ) : path.includes('/ios/') ? (
    <AppleIcon />
  ) : path.includes('/android/') ? (
    <AndroidIcon />
  ) : path.includes('/unity/') ? (
    <UnityIcon />
  ) : path.includes('/edgeauth/') ? (
    <EdgeauthIcon />
  ) : path.includes('/react-native/') ? (
    <ReactIcon />
  ) : (
    <PageIcon />
  );
  return icon;
}
